const state = {
    show: false,
    addresses: null,
    address: {},
    type: 'add',
    count: 0,
    billingAddress: {
        country: null,
        city: null,
        street: null,
        house: null,
        first_name: null,
        last_name: null,
        postcode: null,
        greetings: null
    },
    billingAdddressString: null
}

const mutations = {
    setState: (state, {
        key,
        value
    }) => {
        state[key] = value
    },

    addAddress: (state, v) => {
        if (state.addresses == null) state.addresses = [];

        state.addresses.push(v);
    },

    updateAddress: (state, v) => {
        state.addresses = state.addresses.map(element => {
            if (element.id == v.id) {
                return element = v;
            }
        });
    }
}

const actions = {
    async fetch({
        commit
    }) {
        const response = await this.$api.address.fetch();

        commit('setState', {
            key: "addresses",
            value: response.data.addresses || []
        });

        const len = response.data.addresses != undefined ? response.data.addresses.length : 0;
        commit('setState', {
            key: "count",
            value: len
        });
    },

    async add({
        commit
    }, address) {
        return await this.$api.address.add(address);
    },

    async update({
        commit
    }, address) {
        return await this.$api.address.update(address);
    },

    async delete({
        commit
    }, id) {
        const response = await this.$api.address.delete(id);
    },

    async setDefault({
        commit
    }, id) {
        const response = await this.$api.address.setDefault(id);
    },

    async fetchBillingAddress({
        commit
    }) {
        const response = await this.$api.address.fetchBillingAddress();
        const address = response.data.client_billing_address;
        commit('setState', {
            key: "billingAdddressString",
            value: address ? `${address.street} ${address.house}, ${address.postcode || ''}, ${address.city}` : null
        });
        commit('setState', {
            key: 'billingAddress',
            value: {
                ...address
            }
        });
    },

    async addBillingAddress({
        state
    }) {
        const response = await this.$api.address.addBillingAddress(state.billingAddress);
        return response;
    }
}

const getters = {
    show: state => state.show,
    addresses: state => state.addresses,
    address: state => state.address,
    type: state => state.type,
    isUpdate: state => state.type == 'edit',
    count: state => state.count,
    billingAddress: state => state.billingAddress,
    billingAdddressString: state => state.billingAdddressString
}

export default {
    namespaced: true,

    state,
    mutations,
    actions,
    getters
}